module.exports = __webpack_public_path__ + "static/img/1.0a0a768.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/eng/1.png
// module id = m/Uw
// module chunks = 0